import { render, staticRenderFns } from "./builtRecycle.vue?vue&type=template&id=0c3cb690&scoped=true&"
import script from "./builtRecycle.vue?vue&type=script&lang=js&"
export * from "./builtRecycle.vue?vue&type=script&lang=js&"
import style0 from "./builtRecycle.vue?vue&type=style&index=0&id=0c3cb690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3cb690",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3cb690')) {
      api.createRecord('0c3cb690', component.options)
    } else {
      api.reload('0c3cb690', component.options)
    }
    module.hot.accept("./builtRecycle.vue?vue&type=template&id=0c3cb690&scoped=true&", function () {
      api.rerender('0c3cb690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/builtRecycle.vue"
export default component.exports